import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Browsers report "ResizeObserver loop ..." when an observer callback resizes
// an observed element (Monaco's automaticLayout does this at fractional
// browser zoom). It is benign, but the CRA dev overlay shows it as a fatal
// error. Suppress exactly this message in development.
if (process.env.NODE_ENV === 'development') {
  const benignResizeObserverErrors = [
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
  ];
  let realErrorSeen = false;
  const setOverlayHidden = (hidden: boolean) => {
    // The dev-server client reuses one overlay iframe, so a real error after
    // a hidden benign one must un-hide it (and vice versa never happens:
    // once a real error appeared we stop hiding altogether).
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) overlay.style.display = hidden ? 'none' : '';
  };
  window.addEventListener(
    'error',
    (event) => {
      if (!benignResizeObserverErrors.includes(event.message)) {
        realErrorSeen = true;
        setOverlayHidden(false);
        setTimeout(() => setOverlayHidden(false), 0);
        return;
      }
      event.stopImmediatePropagation();
      event.preventDefault();
      if (realErrorSeen) return;
      // The dev-server client registered its listener first, so it may have
      // shown the overlay already (or will within this task); hide it.
      setOverlayHidden(true);
      setTimeout(() => {
        if (!realErrorSeen) setOverlayHidden(true);
      }, 0);
    },
    true,
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
